const hairColors = ['blonde', 'red', 'black', 'brown'];
const bodyTypes = ['lean', 'big', 'normal', 'athletic'];
const selectDefault = '-- Select --';
export { bodyTypes, hairColors, selectDefault };
